<template>
  <div class="loading loading--plp-main" v-if="isLoading">
    <!-- <LoadingAnimation /> -->
    <div class="plp-loading-title"><span></span></div>
    <div class="plp-loading-content">
      <div class="plp-loading-filter"><span></span></div>
      <div class="plp-loading-grid"><span></span></div>
    </div>
  </div> 
  <div
    class="text-center d-flex align-items-center mx-4 display-4"
    style="min-height: 500px"
    v-else-if="error"
  >
    <axiosError></axiosError>
  </div>

  <div v-else>
    <CollectionHeader :collectionId="collectionId" :sectiondata="sectiondata" />
    <div v-if="quickLinkList.length > 0">
      <QuickLinks :quickLinkList="quickLinkList" />
    </div>

    <StandardCollectionGrid
      :collectionId="collectionId"
      :products="productData"
      :contentBanners="sectiondata.contentBanners"
      :showFilters="sectiondata.showFilters"
      :colorwaySort="colorwaySort"
    />
  </div>
</template>

<script src="./ctrl-standard-collection-container.js"></script>
